import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '@shared/services/storage/session-storage.service';
import { AppConstant } from '@shared/contants/app.constant';

@Injectable({
    providedIn: 'root'
})
export class UtmParamsService {
    private readonly sessionStorageService = inject(SessionStorageService);

    /**
     * Extrae de un conjunto de query params únicamente las claves UTM con valor no vacío.
     */
    extractUtmParams(params: Record<string, unknown> | null | undefined): Record<string, string> {
        if (!params) {
            return {};
        }

        return Object.entries(params).reduce<Record<string, string>>((acc, [key, value]) => {
            if (!key.startsWith('utm_')) {
                return acc;
            }

            const normalizedValue = Array.isArray(value) ? value[0] : value;

            if (normalizedValue === null || normalizedValue === undefined || normalizedValue === '') {
                return acc;
            }

            acc[key] = String(normalizedValue);
            return acc;
        }, {});
    }

    setUtmParams(params: Record<string, string>): void {
        this.sessionStorageService.set(AppConstant.UTM_URL_PARAMS_SESSION_KEY, params);
    }

    /**
     * UTM vigentes para propagar en la URL. Prioriza el mapa completo y cae al
     * almacenamiento histórico de 5 campos para mantener compatibilidad.
     */
    getUtmQueryParams(): Record<string, string> {
        const stored =
            (this.sessionStorageService.get(AppConstant.UTM_URL_PARAMS_SESSION_KEY) as Record<string, unknown> | null) ??
            (this.sessionStorageService.get(AppConstant.UTM_PARAMS_SESSION_KEY) as Record<string, unknown> | null);

        return this.extractUtmParams(stored);
    }

    hasUtm(): boolean {
        return Object.keys(this.getUtmQueryParams()).length > 0;
    }

    isPropagationDone(): boolean {
        return this.sessionStorageService.get(AppConstant.UTM_PROPAGATION_DONE_KEY) === true;
    }

    markPropagationDone(): void {
        this.sessionStorageService.set(AppConstant.UTM_PROPAGATION_DONE_KEY, true);
    }

    resetPropagation(): void {
        this.sessionStorageService.remove(AppConstant.UTM_PROPAGATION_DONE_KEY);
    }
}
